const pdpButton = document.getElementById("pdpReadMore");
if (pdpButton) {
  pdpButton.addEventListener("click", (e) => {
    e.preventDefault();
    e.target.parentElement.classList.toggle("expand");
    if (e.target.parentElement.classList.contains("expand")) {
      pdpButton.textContent = "Read Less";
    } else {
      pdpButton.textContent = "Read More";
    }
  });
}

window.addEventListener("scroll", (event) => {
  let scrollposition = this.scrollY;
  // console.log(scrollposition)
  const modalSidebar = document.querySelector(".header-sidebar__main-panel");
  if (scrollposition > 49) {
    document.body.classList.add("change-height");
    modalSidebar.classList.add("add-sidebar-height");
  } else {
    document.body.classList.remove("change-height");
    modalSidebar.classList.remove("add-sidebar-height");
  }
});

window.addEventListener("load", (event) => {
  document.querySelectorAll(".tab-link").forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelectorAll(".tab-link").forEach((_link) => {
        _link.classList.remove("active");
      });
      this.classList.add("active");
      const tab = this.dataset.tab;

      document.querySelectorAll(".tab-content").forEach((content) => {
        content.classList.add("hidden");
      });
      document.querySelector(`.tab-content[data-tab="${tab}"]`).classList.remove("hidden");

      document.querySelectorAll(".tab-image").forEach((content) => {
        content.classList.add("hidden");
      });
      document.querySelector(`.tab-image[data-tab="${tab}"]`).classList.remove("hidden");

      document.querySelectorAll(".tab-text").forEach((content) => {
        content.classList.add("hidden");
      });
      document.querySelector(`.tab-text[data-tab="${tab}"]`).classList.remove("hidden");
    });
  });
});

// let filterContent = document.querySelector('.facets-sidebar');
// if(screen.width > 768){
//   filterContent.classList.add('hidden');

// }
// function toggleFliterTree() {
//   let filterButton = document.querySelector('[aria-controls="show-filter"]');
//   let filterContent = document.querySelector('.facets-sidebar');
//   let filterIcon = document.querySelector('.filter-icon');
//   let closeIcon = document.querySelector('.filter-close-icon');

//   if (filterButton && filterContent) {
//    filterIcon.classList.toggle('hidden');
//    closeIcon.classList.toggle('hidden');
//    filterContent.classList.toggle('hidden');
//   }
// }

let productsData = [];

document.querySelectorAll(".filter-item a").forEach((item) => {
  item.addEventListener("click", (e) => {
    e.preventDefault();
    let selectedValue = e.target.innerHTML;
    let newUrl = `?selected_option=${encodeURIComponent(selectedValue)}`;
    console.log("Navigating to:", newUrl);

    fetch(`https://staging-shepherds.myshopify.com/collections/${document.getElementById("collection_handle").value}/products.json?limit=250`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok.");
        }
        return response.json();
      })
      .then((data) => {
        console.log("received data==>", data);
        let htmlText = ``;

        const sort_arr = data.products.filter((item) => item.tags[0] === e.target.id);
        const new_arr = sort_arr.concat(data.products);

        const uniq_arr = [...new Set(new_arr)];

        productsData = [...uniq_arr];

        console.log("new array==>", uniq_arr);

        for (let index = 0; index < themeSettings.productsPerPage; index++) {
          htmlText += `
                <div class="product-card">
                    <div class="product-card__figure">
                        <a href="/products/${uniq_arr[index].handle}" class="product-card__media" data-instant>`;

          if (uniq_arr[index].images.length == 0) {
            htmlText += `</a>
                            </div>
                            <div class="gap-1 product-card__info justify-items-start empty:hidden">
                                <div class="w-full gap-2 v-stack">
                                    <div class="flex items-center justify-between gap-1 v-stack">
                                        <div class="text-left">
                                            <strong><a href="/products/${uniq_arr[index].handle}" class="product-title text-left leading-4 text-base font-semibold text-[#0D1E0A] tracking-normal" data-instant>${uniq_arr[index].title}</a></strong>
                                        </div>
                                        <div>
                                            <price-list class="price-list text-xs md:text-sm text-green-10">
                                                <sale-price>
                                                    <span class="sr-only text-xs  md:text-[15px] font-normal text-green-10">Sale price</span>${uniq_arr[index].variants[0].price}
                                                </sale-price>
                                            </price-list>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="text-base leading-6 tracking-normal text-left text-green-10"></span>
                        </div>
                        `;
          } else {
            htmlText += `<img src="${uniq_arr[index].images[0].src}" alt="${uniq_arr[index].title}" width="375" height="532" loading="lazy" class="product-card__image product-card__image--primary  aspect-" />
                            </a>
                            </div>
                            <div class="gap-1 product-card__info justify-items-start empty:hidden">
                                <div class="w-full gap-2 v-stack">
                                    <div class="flex items-center justify-between gap-1 v-stack">
                                        <div class="text-left">
                                            <strong><a href="/products/${uniq_arr[index].handle}" class="product-title text-left leading-4 text-base font-semibold text-[#0D1E0A] tracking-normal" data-instant>${uniq_arr[index].title}</a></strong>
                                        </div>
                                        <div>
                                            <price-list class="price-list text-xs md:text-sm text-green-10">
                                                <sale-price>
                                                    <span class="sr-only text-xs  md:text-[15px] font-normal text-green-10">Sale price</span>${uniq_arr[index].variants[0].price}
                                                </sale-price>
                                            </price-list>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="text-base leading-6 tracking-normal text-left text-green-10"></span>
                        </div>`;
          }
        }

        document.querySelector(".collection__main > product-list").innerHTML = htmlText;
      })
      .catch((error) => {
        console.error("There has been a problem with your fetch operation:", error);
      });
  });
});

// document.querySelectorAll('.pagenation__item').forEach(item => item.addEventListener('click', e => {
//     let htmlText = '';
//     e.preventDefault();

//     const currentPageNum = parseInt(e.target.innerHTML);
//     const startProductNum = (currentPageNum - 1) * themeSettings.productsPerPage;
//     const lastProductNum = productsData.length < currentPageNum * themeSettings.productsPerPage ? productsData.length : currentPageNum * themeSettings.productsPerPage;

//     for (let index = startProductNum; index < lastProductNum; index++) {
//         htmlText += `
//         <div class="product-card">
//             <div class="product-card__figure">
//                 <a href="/products/${productsData[index].handle}" class="product-card__media" data-instant>
//                     <img src="${ productsData[index].images.length != 0 ? productsData[index].images[0].src : "" }" alt="${productsData[index].title}" width="375" height="532" loading="lazy" class="product-card__image product-card__image--primary  aspect-" />
//                 </a>
//             </div>
//             <div class="gap-1 product-card__info justify-items-start empty:hidden">
//                 <div class="w-full gap-2 v-stack">
//                     <div class="flex items-center justify-between gap-1 v-stack">
//                         <div class="text-left">
//                             <strong><a href="/products/${productsData[index].handle}" class="product-title text-left leading-4 text-base font-semibold text-[#0D1E0A] tracking-normal" data-instant>${productsData[index].title}</a></strong>
//                         </div>
//                         <div>
//                             <price-list class="price-list text-xs md:text-sm text-green-10">
//                                 <sale-price>
//                                     <span class="sr-only text-xs  md:text-[15px] font-normal text-green-10">Sale price</span>${productsData[index].variants[0].price}
//                                 </sale-price>
//                             </price-list>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <span class="text-base leading-6 tracking-normal text-left text-green-10"></span>
//         </div>
//         `
//     }
//     document.querySelector('.collection__main > product-list').innerHTML = htmlText;
// }));

// const button = document.querySelector('.js-collection__filter-button');
// const drawer = document.getElementById('facets-drawer');

//   function toggleDrawer() {
//     const isExpanded = button.getAttribute('aria-expanded') === 'true';
//     drawer.style.display = isExpanded ? 'none' : 'block';
//     button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
//   }
//   button.addEventListener('click', toggleDrawer);

const accountDropbtn = document.querySelectorAll(".account-dropbtn");
accountDropbtn.forEach(function (accountDropbtn) {
  accountDropbtn.addEventListener("click", function () {
    let dropdowns = document.querySelectorAll(".account-dropdown-content");
    dropdowns.forEach(function (dropdown) {
      dropdown.classList.toggle("hidden");
      var i;
      for (i = 0; i < dropdown.length; i++) {
        var openDropdown = dropdown[i];
        if (openDropdown.classList.contains("hidden")) {
          openDropdown.classList.remove("hidden");
        }
      }
    });
  });
});

async function toggleMTMFee(e) {
  console.log(e.target);
  const line_item = e.target.closest('[data-line-item]');

  let action = "/cart/add.js"
  let formData = {
   'items': [
      {
        'id': line_item.getAttribute("data-mtm-variant-id"),
        'quantity': line_item.getAttribute("data-qty"),
        'properties': {
          "Product": line_item.getAttribute("data-line-title"),
          "_mtm": line_item.getAttribute("data-line-ts")
        }
      }
    ]
  };
 
  if (!e.target.checked) {
    action = "/cart/change.js"
    formData = {
      'id': line_item.getAttribute("data-mtm"),
      'quantity': 0
    };
  }

  fetch(action, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
  .then((response) => response.json())
  .then(async (data) => {
      setTimeout(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 200);
      if (window.themeVariables.settings.pageType === "cart") {
        window.location.reload();
      }
  })
  .catch((error) => console.error(error));
}

async function sendKlaviyo(listId, e) {
  try {
    e.preventDefault();
    const form = e.target;

    const url = `https://manage.kmail-lists.com/ajax/subscriptions/subscribe`;
    const profiles = new URLSearchParams();

    profiles.append(
      "email",
      form.querySelector('[name="email"]').value,
    );
    profiles.append("$fields", "$source");
    profiles.append("g", listId);

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
      },
      body: profiles,
    });

    form.classList.add('form-submited');

    return await res.json();
  } catch (e) {
    console.log(e);
  }
}
// ── UTM persistence: capture from URL and store in cookie ──
(function() {
  var params = new URLSearchParams(window.location.search);
  var keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid'];
  var utm = {};
  keys.forEach(function(k) { if (params.get(k)) utm[k] = params.get(k); });
  if (Object.keys(utm).length > 0) {
    var expires = new Date(Date.now() + 24*60*60*1000).toUTCString();
    var val = encodeURIComponent(JSON.stringify(utm));
    document.cookie = 'shepherd_utms=' + val + '; path=/; expires=' + expires + '; SameSite=Lax';
  }
})();

// ── Shared UTM reader: URL first, cookie fallback ──
window.getStoredUtms = function() {
  var params = new URLSearchParams(window.location.search);
  var keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid'];
  var utm = {};
  keys.forEach(function(k) { if (params.get(k)) utm[k] = params.get(k); });
  if (Object.keys(utm).length > 0) return utm;
  try {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      if (c.indexOf('shepherd_utms=') === 0) {
        return JSON.parse(decodeURIComponent(c.substring('shepherd_utms='.length)));
      }
    }
  } catch(e) {}
  return {};
};

// ── Global Cal.com modal trigger with UTM forwarding ──
window.triggerCalPopup = function(calUrl) {
  function openModal() {
  Cal.config = Cal.config || {};
  Cal.config.forwardQueryParams = true;
  var utms = window.getStoredUtms ? window.getStoredUtms() : {};
  Cal('modal', { calLink: calUrl, config: { theme: 'light' }, metadata: utms });
  }
  if (typeof window.Cal === 'undefined') {
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal; let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {}; cal.q = cal.q || [];
          d.head.appendChild(d.createElement('script')).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ['initNamespace', namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');
    Cal('init', { origin: 'https://cal.com' });
    setTimeout(openModal, 50);
  } else {
    openModal();
  }
};